<template>
  <img alt="Adivina logo" src="../assets/logo.png">
  <h1>Adivina</h1>
  <p>Piensa en un número entre 0 y 50, luego pulsa en Comenzar.
    <br>
    Si ves tu número pulsa Sí, y si no lo ves pulsa No.
  </p>
  <p>
    <button @click="$emit('start')">Comenzar</button>
  </p>
  <h6>Juego desarrollado por <a href="https://apps.salcarman.es">@Salcarman</a></h6>
</template>

<script>
export default {
  name: 'StartComponent',
  props: {
  },
  methods: {
  },
  emits: ['start']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
